import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { DateDisplayType } from '../enums/date-display-type.enum';

@Pipe({ name: 'ldmDatePipe' })
@Injectable({
  providedIn: 'root'
})
export class LdmDatePipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  transform(
    value: any,
    dateType: DateDisplayType = DateDisplayType.DateTime
  ): any {
    if (value !== null) {
      const date = new Date(value);

      var timeZone = '';

      const dateString = this.datePipe.transform(date, 'yyyy-MM-dd');
      const dateFileString = this.datePipe.transform(date, 'yyyyMMdd');
      const timeString = this.datePipe.transform(date, 'HH:mm:ss', timeZone);
      const timeStringWithoutSeconds = this.datePipe.transform(date, 'HH:mm', timeZone);

      if (dateType === DateDisplayType.DateTime) {
        return dateString + ' ' + timeString;
      } else if (dateType === DateDisplayType.DateTimeWithoutSeconds) {
        return dateString + ' ' + timeStringWithoutSeconds;
      } else if (dateType === DateDisplayType.Time) {
        return timeString;
      } else if (dateType === DateDisplayType.TimeWithoutSeconds) {
        return timeStringWithoutSeconds;
      } else if (dateType === DateDisplayType.Date) {
        return dateString;
      } else if (dateType === DateDisplayType.DateForFile) {
        return dateFileString;
      } 
    } else {
      return '';
    }
  }
}
